import styled from 'styled-components'
import colors from './colors'
import { Body2 } from './Typo'

export const BubbleItem = styled(Body2)`
  display: inline-block;
  margin-right: 1rem;
  &:before {
    content: ' ';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid ${colors.Entry.floorItem};
    display: inline-block;
    position: relative;
    top: 1px;
    margin-right: 0.5rem;
  }
`
